module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 16.f2ff7aae.png";